import React from 'react';
import { FaEnvelope, FaPhone } from 'react-icons/fa';
import './Page.css';
 
const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 2024</p>
      </div>
 
      <div className="privacy-content">
        <section className="policy-section">
          <h2>Introduction</h2>
          <p>
            Welcome to Visit Guru. We are committed to protecting your personal data and ensuring transparency about how your information is collected, used, and shared. This Privacy Policy applies to all users—customers, vendors, and employees—who use our application and services across India.
          </p>
        </section>
 
        <section className="policy-section">
          <h2>Information We Collect</h2>
          <div className="info-grid">
            <InfoCard
              title="Personal Information"
              items={['Name', 'Phone number', 'Email', 'Address']}
            />
            <InfoCard
              title="Service Details"
              items={['Bookings', 'Service history', 'Feedback']}
            />
            <InfoCard
              title="Vendor/Employee Information"
              items={[
                'Business details',
                'Employee records',
                'Performance reports',
                'Leave data',
              ]}
            />
          </div>
        </section>
 
        <section className="policy-section contact-section">
          <h2>Contact Us</h2>
          <div className="contact-info">
            <ContactCard
              icon={<FaEnvelope />}
              text="Email: visitguruservicespvt.ltd.786@gmail.com"
            />
            <ContactCard
              icon={<FaPhone />}
              text="Phone: +91 9316688676"
            />
          </div>
        </section>
      </div>
    </div>
  );
};
 
const InfoCard = ({ title, items }) => (
  <div className="info-card">
    <h3>{title}</h3>
    <ul>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
);
 
const ContactCard = ({ icon, text }) => (
  <div className="contact-card">
    {icon}
    <p>{text}</p>
  </div>
);
 
export default PrivacyPolicy;
 